<template>
  <div>
    <v-list flat class="workstatus-list">
      <v-list-item-group v-for="(item, index) in searchList" :key="item.sabun">
        <v-list-item :ripple="false">
          <v-list-item-content>
            <v-list-item-title class="d-flex justify-space-between"
              ><div>
                <span class="name">{{ item.empNm }}</span
                ><span class="divider position">{{ item.jikweeNm }}</span>
              </div>
              <v-chip-group class="chips-wrap" v-show="item.gntlist != null">
                <div v-for="chipItem in item.gntlist" :key="chipItem.id">
                  <v-chip label :class="`bc${chipItem.color}`">
                    {{ chipItem.name }}
                  </v-chip>
                </div>
              </v-chip-group>
            </v-list-item-title>
            <v-list-item-subtitle
              v-show="
                (authGubun == 'Employee' && GET_EMP_INOUT_USE_YN) ||
                authGubun != 'Employee'
              "
            >
              <span class="label">{{ $t('출근') }}</span>
              <span class="time">{{ item.inHmF }}</span>
              <span class="label ml-4">{{ $t('퇴근') }}</span>
              <span class="time">{{ item.outHmF }}</span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider
          v-show="searchList.length > index + 1"
          inset
          class="list-divider-line"
        ></v-divider>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
/* 부서원근무근태현황 목록 컴포넌트 */
import { mapGetters } from 'vuex';

export default {
  props: {
    searchList: [],
    authGubun: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters('MENU', ['GET_EMP_INOUT_USE_YN']),
  },
};
</script>

<style></style>
